module.exports = __webpack_public_path__ + "img/Bodice-Front-B1-Db-Ec-Fb-Gb.5950bfba.png";